exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/projects/projects.component.less
// module id = ../../../../../src/app/projects/projects.component.less
// module chunks = main